import ProjectViewPage from "./pages/ProjectViewPage";

export default [
  { path: "/project/:projectId", element: <ProjectViewPage /> }
];